import React, {ChangeEvent} from "react";
import {AppApi} from "../../../utils/AppApi";
import {useAlert} from "../../../utils/components/providers/AlertProvider";
import {useAppDispatch} from "../../../utils/store/store";
import {updateUser} from "../../../utils/store/userSlice";
import {Utils} from "../../../utils/Utils";

export default function AdminLogin() {
    const dispatch = useAppDispatch()
    const {showMessage} = useAlert()
    const [credentials, setCredentials] = React.useState({username: "", password: ""})

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCredentials({...credentials, [event.target.name]: event.target.value})
    }

    const loginUser = () => {
        Utils.toggleSpinner('show')
        AppApi.adminLogIn({password: credentials.password, username: credentials.username})
            .then(response => {
                Utils.toggleSpinner('hide')
                if (response.data.success) {
                    dispatch(updateUser(response.data['admin']))
                } else {
                    showMessage({message: response.data['message'], type: 'error'})
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: "Unable to login, please try again", type: 'error'})
            })
    }

    return (
        <div className="container-xxl position-relative bg-white d-flex p-0">
            {/* Sign In Start */}
            <div className="container-fluid">
                <div className="row h-100 align-items-center justify-content-center" style={{minHeight: '100vh'}}>
                    <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
                        <div className="bg-light rounded p-4 p-sm-5 my-4 mx-3">
                            <div className="d-flex align-items-center justify-content-between mb-3">
                                <a href="/" className="">
                                    <h3 className="text-primary"><i className="fa fa-user me-2"></i>Member</h3>
                                </a>
                                <h3>Sign In</h3>
                            </div>

                            <form method="post">
                                <div className="mb-3">
                                    <label htmlFor="username" className="form-label">Username</label>
                                    <input type="text" className="form-control" id="username" name="username"
                                           value={credentials.username} onChange={handleChange} required/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <input type="password" className="form-control" id="password" name="password"
                                           value={credentials.password} onChange={handleChange} required/>
                                </div>
                                <button type="button" className="btn btn-primary" onClick={loginUser}>Login</button>
                                {/* Forgot Password Link */}

                                <div className="mt-3">
                                    <span className={'span_link'}>Forgot Password?</span>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* Sign In End */}
        </div>
    )
}